import VForm from '@/vuetify_custom/v-form'
import { mapGetters } from 'vuex'
import VTable from '@/vuetify_custom/v-table/v3'
import { publish_form_list } from '@/views/blogger/fields.js'
import VPopDel from './v-pop-del'
import styles from './index.module.less'
import {contract_types_mixins} from './EditMixIns.jsx'
// Textareas_Field
import { common_mixins } from './EditMixIns.jsx'
import { postContractRelatedPlacingRecordDeleteApi, postOutsourceContractRelatedPlacingRecordDeleteApi } from '../service'
export default {
    mixins:[common_mixins, contract_types_mixins],
    props: {
        contractType: {
            type: String,
        },
        list: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false,
        },
        pParams: {
            type: Object,
            default: () => ({}),
        }
    },
    data() {
        return {
            hash: {},
            is_expand: true
        }
    },
    computed: {
        ...mapGetters({
            contract_types_hash: 'async/contract_types_hash',
        }),
        cur_customer() {
            return this.$store.state.cur_customer;
          },
        is_financer() {
            return this.cur_customer.groups && this.cur_customer.groups.includes('GROUP_FIN');
        },
        placing_ads_ids_hash() {
            if (!this.params.ads_record_ids) {
                return {}
            }
            return this.params.ads_record_ids.reduce((t, i) => {
                if (i.id) {
                    t[i.id] = true
                }
                return t
            }, {})
        },
        table_fields() {
            const _this = this
            return [
                {
                    text: '投放编号',
                    align: 'center',
                    value: 'uid',
                    width: 240,
                }, 
                {
                    text: '预计投放时间',
                    align: 'center',
                    value: 'estimate_publish_at',
                    width: 120,
                },
                {
                    text: '发布时间',
                    align: 'center',
                    value: 'publish_at',
                    width: 120,
                },
                {
                    text: '发布类型',
                    align: 'center',
                    value: 'publish_form',
                    type: 'list_field',
                    item_key: 'value',
                    item_text: 'label',
                    items:publish_form_list,
                    width: 120,
                },
                {
                    text: '发布平台',
                    align: 'center',
                    value: 'platform',
              
                    width: 120,
                    renderv:(_, __, target) => {
                        target = target || {}
                        return <div>{target.kol && target.kol.platform || '-'}</div>
                    }
                },
                {
                    text: '对接人',
                    align: 'center',
                    value: 'docking_customer_name',
                    width: 120,
                },
                {
                    text: '项目组',
                    align: 'center',
                    type: 'team_field',
                    value: 'team_id',
                    width: 120,
                },
                {
                    text: 'SKU',
                    align: 'center',
                    value: 'sku',
                    width: 120,
                    render:(_, t) => <div>{t.sku && t.sku.sku_name || '-'}</div>
                },
                {
                    text: '预计投放金额',
                    align: 'center',
                    value: 'total_price',
                    type: 'money_field',
                    width: 120,
                },
                {
                    text: '操作',
                    align: 'center',
                    type: 'button_g_field',
                    value: 'action',
                     width: 120,
                     fixed: 'right',
                    render: (_, params) => {
                        // if (_this.params.contract_is_finished) {
                        //     return 
                        // }
                      
                        return <div>
                            <VPopDel
                                title="确定删除该条数据？"
                                on={{
                                    submit:() => {
                                        const post = this.contractType === 'outsource' ? postOutsourceContractRelatedPlacingRecordDeleteApi : postContractRelatedPlacingRecordDeleteApi
                                        post({record_id: params.id, id:this.pParams.id}).then(() => {
                                            this.$emit('delete')
                                        })
                                    }
                                }}
                            />
                    
                        </div>
                    }
                }
            ]
        },
        fields() {
            return [
                {
                    key:'table',
                    cols: 12,
                },
            ]
        }
    },
    methods: {
        changeUid(item, index) {
            this.$set(this.params.ads_record_ids, index, item)
        },
    },
    render() {
        const _this = this
        return <div class={styles['block-margin']}>
         <VForm
                ref="base"
                fields={_this.fields}
                scopedSlots={{
                    table:() => {
                        return <VTable
                            headers={this.table_fields}
                            desserts={this.list}
                            loading={this.loading}
                            
                        />
                    }
                }}
            />
    </div>
    }
}